const SIMPLE_CONTAINER_ENV = process.env.REACT_APP_SIMPLE_CONTAINER_ENV;

export const isProd = (): boolean => SIMPLE_CONTAINER_ENV === "production";
export const isStaging = (): boolean => SIMPLE_CONTAINER_ENV === "staging";
export const isLocal = (): boolean => SIMPLE_CONTAINER_ENV === "local";
